module.exports = __webpack_public_path__ + "assets/img/btn-detail-2a5bb42a.png";